import React, { useCallback, useState, useEffect } from 'react'
import { useMount } from 'react-use'
import dayjs from 'dayjs'
import * as apis from '@/apis'
import SelectRetailReferral from '@/components/SelectRetailReferral';
import { Avatar, message, Modal, Button, Checkbox, Select } from 'antd'

const styles = {
  container: {
    padding: '20px 24px'
  },
  title: {
    fontSize: 16,
    marginBottom: 24,
    fontWeight: 'normal'
  },
  section: {
    marginBottom: 16
  },
  sectionTitle: {
    fontSize: 14,
    marginBottom: 12
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 24
  },
  userAvatar: {
    marginRight: 8
  },
  userAccount: {
    color: '#999',
    fontSize: 14
  },
  subLevel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 15
  },
  subLevelLeft: {
    display: 'flex',
    alignItems: 'center'
  },
  subLevelTitle: {
    fontSize: 14,
    marginRight: 8
  },
  userCount: {
    fontSize: 14
  },
  subLevelRight: {
    display: 'flex',
    alignItems: 'center'
  },
  userList: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
    background: '#fff',
    border: '1px solid #f0f0f0',
    borderRadius: 2,
    minHeight: 200  // 确保即使没有数据也有一定高度
  },
  userItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 16px',
    borderBottom: '1px solid #f0f0f0'
  },
  checkbox: {
    marginRight: 12
  },
  footer: {
    marginTop: 20,
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 8
  }
}

export default function RetailManagerList(props) {
  const [loading, setLoading] = useState(false)
  const [total, setTotal] = useState(0)
  const [list, setList] = useState([])
  const [binding, setBinding] = useState();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([])
  const [selectedReferral, setSelectedReferral] = useState(null)

  const fetch = useCallback(() => {
    setLoading(true)
    const params = {}
    console.log('props',props)
    if (props.referral) {
      params.retail = props.referral.user._id
      params.limit = 100
    }

    apis.getRetailBindedList(props.referral.user._id).then(result => {
      setLoading(false)
      setTotal(result.total)
      setList(result.data)
    })
  }, [props.referral, props.tenant])

  useMount(fetch)

  useEffect(() => {
    return () => {
      if (props.refreshList) {
        props.refreshList()
      }
    }
  }, [props.refreshList])

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedUsers(list.map(item => item.retail._id))
    } else {
      setSelectedUsers([])
    }
  }

  const handleSelect = (id) => {
    const newSelected = selectedUsers.includes(id) 
      ? selectedUsers.filter(item => item !== id)
      : [...selectedUsers, id]
    setSelectedUsers(newSelected)
  }

  const handleBatchUnbind = () => {
    if (selectedUsers.length === 0) {
      message.warning('请选择要解绑的散户')
      return
    }
    
    Modal.confirm({
      title: '批量解绑',
      content: '确定要解除选中散户的绑定关系吗？',
      onOk: () => {
        console.log('selectedUsers',selectedUsers)
        Promise.all(selectedUsers.map(id => {
          console.log('list',list)
          console.log('id',id)
          const item = list.find(i => i.retail._id.toString() == id)
          console.log('item',item)
          return apis.unbindRetailReferral(props.referral.user._id, {
            retail: item.retail._id
          })
        })).then(() => {
          message.success('批量解绑成功')
          setSelectedUsers([])
          fetch()
        }).catch(err => {
          message.error(err.message || '操作失败')
        })
      }
    })
  }

  const handleAssignReferral = () => {
    if (selectedUsers.length === 0) {
      message.warning('请选择要绑定的用户')
      return
    }

    if (!selectedReferral) {
      message.warning('请选择推广人')
      return
    }
    console.log('selectedReferral',selectedReferral)
    Modal.confirm({
      title: '指定绑定人',
      content: '确定要将选中用户绑定到该推广人吗？',
      onOk: () => {
        Promise.all(selectedUsers.map(id => {
          const item = list.find(i => i.retail._id.toString() === id)
          return apis.changeRetailReferral(props.referral.user._id, selectedReferral, {
            retail: item.retail._id
          })
        })).then(() => {
          message.success('绑定成功')
          setSelectedUsers([])
          setSelectedReferral(null)
          fetch()
        }).catch(err => {
          message.error(err.message || '操作失败')
        })
      }
    })
  }

  const UserCell = ({ user }) => {
    if (!user) return null;
    return (
      <div style={styles.userItem}>
        <Checkbox
          checked={selectedUsers.includes(user._id)}
          onChange={() => handleSelect(user._id)}
          style={styles.checkbox}
        />
        <Avatar size={32} src={user?.user?.logo} style={{ marginRight: 8 }} />
        <span style={{ color: '#666' }}>{user?.user?.name || ('用户'+"("+user?.user?.mobile.slice(-4)+")")}</span>
      </div>
    );
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>管理分佣关系</h2>

      <div style={styles.section}>
        <div style={styles.sectionTitle}>用户</div>
        <div style={styles.userInfo}>
          <Avatar size={32} src={props.referral?.user?.avatar} style={styles.userAvatar} />
          <span style={styles.userAccount}>{props.referral?.user?.name}/{props.referral?.user?.mobile}</span>
        </div>
      </div>

      <div style={styles.section}>
        <div style={styles.subLevel}>
          <div style={styles.subLevelLeft}>
            <span style={styles.subLevelTitle}>他的下一级</span>
            <span style={styles.userCount}>散户数：{total}</span>
          </div>
          <div style={styles.subLevelRight}>
            <Checkbox 
              style={styles.checkbox} 
              onChange={handleSelectAll}
              checked={list.length > 0 && selectedUsers.length === list.length}
              indeterminate={selectedUsers.length > 0 && selectedUsers.length < list.length}
            >
              全选
            </Checkbox>
            <Button type="primary" onClick={handleBatchUnbind} style={{ marginRight: 8 }}>一键解绑</Button>
            <SelectRetailReferral 
              style={{ width: 180 }} 
              placeholder="请输入推广人" 
              value={selectedReferral}
              onChange={(value) => setSelectedReferral(value)}
            />
            <Button type="primary" onClick={handleAssignReferral}>指定绑定人</Button>
          </div>
        </div>

        <div style={styles.userList}>
          {list.map((user, index) => (
            <UserCell key={user._id} user={user.retail} />
          ))}
        </div>
      </div>

      {/* <div style={styles.footer}>
        <Button type="primary">确定</Button>
        <Button>取消</Button>
      </div> */}
    </div>
  )
}
